<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;" @click="$router.go(-1)">客户列表</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">客户详情</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>


        <!-- 上半部分 -->
        <div class="detailContent">
            <div class="upperInfoContent">
                <div class="title">
                    <span class="name"><span v-if="cluedetail.username">{{cluedetail.username}}</span>
                    <span class="name" v-else>--</span></span>
                    <!-- <a-tag color="orange">{{cluedetail.clue_type}}</a-tag> -->
                </div>
                 <div class="back-btn">
                    <a-button style="margin-right:12px" @click="back" type="primary">返回</a-button>
                    <a-button-group>
                        <a-button @click="prev" icon="left" />
                        <a-button @click="next" icon="right" />
                    </a-button-group>
                </div>

                <div class="fieldContainer">
                    <div class="fieldItem">
                        <span>手机：</span>
                        <span v-if="cluedetail.telephone">
                            <a v-if="pwdtype==1" href="javascript:;">{{cluedetail.telephone}}</a>
                            <a v-if="pwdtype==2" href="javascript:;">{{cluedetail.telephone | topwd}}</a>
                            <a v-if="pwdtype==3" href="javascript:;">{{cluedetail.telephone | tomd5}}</a>
                        </span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>地址：</span>
                        <span v-if="cluedetail.address">{{cluedetail.address}}</span>
                        <span v-else>--</span>   
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>最近跟进时间：</span>
                        <span v-if="cluedetail.updatetime">{{cluedetail.updatetime | formatDate}}</span>
                        <span v-else>--</span>
                    </div>
                </div>

                <div class="btnListContainer" >
                    <!-- <a-button @click="tokehu" type="primary"><a-icon type="snippets" theme="filled"/>跟进线索</a-button> -->
                    <a-button @click="totel(usid)"><a-icon type="phone" theme="filled"/>拨打电话</a-button>
                </div>
            </div>
        </div>

        <!-- 下半部分 -->
        <div class="lowerInfoContent">
            <div class="basicinfo">
                
                <div class="information">
                    <div class="informationLeft">
                        <div class="title">
                            <img src="../../../static/flag.png" alt="">
                            <span>基本信息</span>
                        </div>
                        <a-descriptions bordered :column="2" :size="size">
                             <a-descriptions-item label="姓名">
                            {{cluedetail.username}}
                            </a-descriptions-item>
                           
                            <a-descriptions-item label="性别">
                            <span v-if="cluedetail.sex==1">男</span>
                            <span v-if="cluedetail.sex==2">女</span>
                            <span v-else>--</span>
                            <!-- <span v-if="cluedetail.sex==1">男</span>
                            <span v-else>女</span> -->
                            </a-descriptions-item>
                             <a-descriptions-item label="电话">
                            <span v-if="pwdtype==1">{{cluedetail.telephone}}</span>
                            <span v-if="pwdtype==2">{{cluedetail.telephone | topwd}}</span>
                            <span v-if="pwdtype==3">{{cluedetail.telephone | tomd5}}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="线索来源">
                            {{cluedetail.title_sources}}
                            </a-descriptions-item>
                            <a-descriptions-item label="付款状态">
                                <a-tag v-if="cluedetail.state_pay==0" color="orange">未支付</a-tag>
                                <a-tag v-if="cluedetail.state_pay==1" color="green">已支付</a-tag>
                                <a-tag v-if="cluedetail.state_pay==3" color="blue">已退款</a-tag>
                            </a-descriptions-item>
                             <a-descriptions-item label="物流状态">
                                <a-tag v-if="cluedetail.state_wl=='未发货'" color="orange">{{cluedetail.state_wl}}</a-tag>
                                <a-tag v-if="cluedetail.state_wl=='已签收'" color="blue">{{cluedetail.state_wl}}</a-tag>
                                <a-tag v-if="cluedetail.state_wl=='已激活'" color="green">{{cluedetail.state_wl}}</a-tag>
                            </a-descriptions-item>
                            <a-descriptions-item label="激活状态">
                                <a-tag v-if="cluedetail.state_jh=='未激活'" color="orange">{{cluedetail.state_jh}}</a-tag>
                                <a-tag v-if="cluedetail.state_jh=='已激活'" color="green">{{cluedetail.state_jh}}</a-tag>
                            </a-descriptions-item>
                            <a-descriptions-item label="跟进时间">
                            {{cluedetail.updatetime | formatDate}}
                            </a-descriptions-item>
                            <!-- <a-descriptions-item label="状态">
                            未激活
                            </a-descriptions-item> -->
                        
                            <a-descriptions-item label="地址" :span="3">
                            {{cluedetail.province}}{{cluedetail.city}}{{cluedetail.area}}{{cluedetail.address}}
                            </a-descriptions-item>
                            <a-descriptions-item label="备注" :span="3">
                            {{cluedetail.remarks}}
                            </a-descriptions-item>
                        </a-descriptions>
                    </div>
                    <div class="informationRight">
                        <div class="title" style="margin-bottom:6px">
                            <img src="../../../static/flag.png" alt="">
                            <span>客户动态</span>
                        </div>

                        <a-tabs default-active-key="1" >
                            <a-tab-pane key="1" tab="跟进动态">
                                <a-timeline v-if="recordlist.length>0" style="padding-top:10px">
                                    <div v-for="(item,i) in recordlist" :key="i">
                                        <a-timeline-item >
                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                            <div class="date-arrow">{{item.addtime | formatDate}}</div>
                                        </a-timeline-item>
                                        <a-timeline-item>
                                            <div class="description">
                                                <div class="dataContainer">
                                                    <div v-if="item.fileurl" style="padding-top:20px">
                                                        <audio class="detail-audio" controls="controls"  :src="item.fileurl"></audio> 
                                                    </div>
                                                    <span class="follow-title" v-if="item.title_isvalid">{{item.title_isvalid}}</span>
                                                    <span class="follow-date" v-if="item.callOutStartTime"><a-icon type="clock-circle"/>{{item.callOutStartTime}}</span>
                                                    <span class="follow-date" v-else><a-icon type="clock-circle"/>{{item.addtime | showdate}}</span>
                                                    <div class="gjcontent" v-if="item.remarks_log">{{item.remarks_log}}</div>
                                                    <div class="cz-user"><p>操作人：<span>{{item.username_kf}}</span></p></div>
                                                </div>
                                            </div>

                                        </a-timeline-item>
                                    </div>
                                </a-timeline>

                                <a-empty v-else description="暂无数据"/>
                            </a-tab-pane>
                            <a-tab-pane key="2" tab="物流动态" force-render>
                                <a-timeline v-if="data_logistics" style="padding-top:10px">
                                    <div v-for="(item,i) in data_logistics" :key="i">
                                        <a-timeline-item >
                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                            <div class="date-arrow">{{item.time}}</div>
                                        </a-timeline-item>
                                        <a-timeline-item>
                                            <div class="description">
                                                <div class="dataContainer">
                                                    <span class="follow-date"><a-icon type="clock-circle"/>{{item.time}}</span>
                                                    <div class="gjcontent">{{item.context}}</div> 
                
                                                    <!-- <div class="cz-user"><p>操作人：<span>{{item.user_name}}</span></p></div> -->
                                                </div>
                                            </div>
                                        </a-timeline-item>
                                    </div>
                                </a-timeline>

                                <a-empty v-else description="暂无数据"/>
                            </a-tab-pane>
                        </a-tabs>
                        
                    </div>
                </div>
                 
            </div>
        </div>

    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import md5 from 'js-md5'
export default {
    filters: {
      //年-月-日
        formatDate (time) {
            time = time * 1000
            let date = new Date(time)
            return formatDate (date, 'yyyy-MM-dd')
        },
        showdate (time) {
            time = time * 1000
            let date = new Date(time)
            return formatDate (date, 'yyyy-MM-dd hh:mm:ss')
        },

        topwd (value) {
            const start = value.slice(0, 3)
            const end = value.slice(-4)
            return `${start}****${end}`
        },
        tomd5(value){
            const text=md5(value)
            const text2=text.slice(0,10);
            return text2
        }
    },
    data(){
        return{
            cluedetail:"",
            data_logistics:"",
            editvisible:false,
            numshow:true,
            form: this.$form.createForm(this, { name: 'coordinated' }),
            gjrecord:[{date:'2021-06-07',add_time:'2021-06-07',user_name:'admin',content:'跟进内容'}],
            size:'middle',

            usid:"",
            kid:"",
            recordlist:"",
            upnext:"",

            pwdtype:""
        }
    },
    mounted(){
        this.usid=this.$route.query.id
        this.kid=this.$route.query.kid
        this.getdetail()
        this.getrecord()
        this.pwdtype=localStorage.getItem('pwdtype')
    },
    methods:{
        // 上一条，下一条
        prev(){
           this.upnext=1
           this.getnextprev()
        },
        next(){
            this.upnext=2
            this.getnextprev()
        },

        getnextprev(){
             this.$axios.post('/api/user/userupnextpage',{
                aid:localStorage.getItem('aid'),
                usid:this.usid,
                upnext:this.upnext
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.cluedetail=res.data.data
                    this.data_logistics=eval('(' + res.data.data.data_logistics + ')')
                    this.usid=res.data.data.usid
                    console.log(this.data_logistics)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        back(){
            this.$router.go(-1);//返回上一层
        },
        totel(id){
            // console.log(id)
            this.$axios.get('https://fxbkfluyin.13524.net/call_do1.php?usxsid='+id,{},{
                headers: {
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.code==100){
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
         // 跟进记录
        getrecord(){
            this.$axios.post('/api/user/userloglist1',{
                pagesize: 30,
                usid:this.kid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var data=res.data.data
                    this.recordlist=data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        // 拨打电话
        call(id){

        },

        // 跟进线索
        handleCancel(){
            this.editvisible=false
        },
        tokehu(id){
            this.editvisible=true
        },
        khhandleOk(){

        },
        sexSelectChange(){

        },
        ondateChange(date, dateString) {
            console.log(date, dateString);
        },
        ontypeChange(e) {
            if( e.target.value==0){
                this.numshow=true
            }else if( e.target.value==1){
                this.numshow=false
            }
        },

        // 详情

        getdetail(){
            this.$axios.post('/api/user/userpage',{
                usid:this.kid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.cluedetail=res.data.data
                    this.data_logistics=eval('(' + res.data.data.data_logistics + ')')
                    // console.log(this.data_logistics)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/resources/customdetail.vue